import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList } from "vue"

const _hoisted_1 = { class: "add-calendar-event" }
const _hoisted_2 = { class: "d-flex align-items-center font-size-lg px-3 py-2 bg-white add-calendar-event__header" }
const _hoisted_3 = { class: "fw-bold" }
const _hoisted_4 = {
  key: 0,
  class: "d-flex align-items-center font-size-xs edit-info"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-info-circle text-secondary ms-2 me-2" }, null, -1 /* HOISTED */)
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", null, "You're editing this event in the series", -1 /* HOISTED */)
const _hoisted_8 = {
  key: 1,
  class: "conflict-warning d-flex align-items-center font-size-xs"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-info-circle ms-2 me-2" }, null, -1 /* HOISTED */)
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Not everyone is available. ")
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = { class: "add-calendar-event__section" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "add-calendar-event__label" }, [
  /*#__PURE__*/_createTextVNode("Title"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_14 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "add-calendar-event__label mt-3" }, [
  /*#__PURE__*/_createTextVNode("Participants"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_16 = { key: 1 }
const _hoisted_17 = {
  key: 2,
  class: "field-invalid"
}
const _hoisted_18 = { class: "add-calendar-event__section" }
const _hoisted_19 = { class: "d-flex justify-content-end align-items-center pb-2" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "me-2 fw-bold" }, "All Day", -1 /* HOISTED */)
const _hoisted_21 = { class: "form-check form-switch mb-0" }
const _hoisted_22 = ["checked"]
const _hoisted_23 = { class: "row g-2 align-items-end" }
const _hoisted_24 = { class: "col-12 col-md-4" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { class: "add-calendar-event__label" }, [
  /*#__PURE__*/_createTextVNode("Date"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_26 = { class: "input-group date datepickerInput" }
const _hoisted_27 = ["value"]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_29 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_30 = {
  key: 0,
  class: "col-12 col-md-4"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", { class: "add-calendar-event__label" }, [
  /*#__PURE__*/_createTextVNode("Start Time"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_32 = {
  key: 1,
  class: "col-12 col-md-4"
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", { class: "add-calendar-event__label" }, [
  /*#__PURE__*/_createTextVNode("End Time"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_34 = {
  key: 0,
  class: "d-flex align-items-end flex-wrap ps-1 mt-2 gap-2"
}
const _hoisted_35 = { class: "w-40" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", { class: "add-calendar-event__label" }, "Repeat", -1 /* HOISTED */)
const _hoisted_37 = ["value"]
const _hoisted_38 = ["value"]
const _hoisted_39 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_40 = /*#__PURE__*/_createElementVNode("span", { class: "me-2" }, "Every", -1 /* HOISTED */)
const _hoisted_41 = ["value"]
const _hoisted_42 = ["value"]
const _hoisted_43 = { class: "ms-2" }
const _hoisted_44 = {
  key: 0,
  class: "form-group w-100"
}
const _hoisted_45 = /*#__PURE__*/_createElementVNode("label", {
  for: "days",
  class: "mb-2"
}, "Repeat On", -1 /* HOISTED */)
const _hoisted_46 = {
  key: 1,
  class: "w-40"
}
const _hoisted_47 = /*#__PURE__*/_createElementVNode("label", {
  for: "on-date",
  class: "add-calendar-event__label"
}, "On Date", -1 /* HOISTED */)
const _hoisted_48 = { class: "input-group date datepickerInput" }
const _hoisted_49 = ["value"]
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_51 = { class: "w-40" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("label", {
  for: "date",
  class: "add-calendar-event__label"
}, "End Date", -1 /* HOISTED */)
const _hoisted_53 = { class: "input-group date datepickerInput pe-2" }
const _hoisted_54 = ["value"]
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_56 = { class: "mt-2" }
const _hoisted_57 = { class: "add-calendar-event__section" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("label", { class: "add-calendar-event__label" }, "Description", -1 /* HOISTED */)
const _hoisted_59 = { class: "d-flex justify-content-center py-3" }
const _hoisted_60 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TagsInput = _resolveComponent("TagsInput")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_MeetingTimePicker = _resolveComponent("MeetingTimePicker")!
  const _component_DayPicker = _resolveComponent("DayPicker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.dialogTitle), 1 /* TEXT */),
      _createElementVNode("i", {
        class: "ms-auto fas fa-times-circle text-danger cursor-pointer",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.cancel()))
      })
    ]),
    (_ctx.mode === 'edit' && _ctx.initialEventType === 'recurring')
      ? (_openBlock(), _createElementBlock("section", _hoisted_4, [
          _hoisted_5,
          (_ctx.isEditSeries)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, "You're editing this and all the following events in this series."))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _hoisted_7,
                _createElementVNode("button", {
                  type: "button",
                  class: "edit-series-btn fw-semibold ms-auto bg-white",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isEditSeries = true))
                }, " Edit entire series ")
              ], 64 /* STABLE_FRAGMENT */))
        ]))
      : _createCommentVNode("v-if", true),
    (_ctx.showConflictWarning)
      ? (_openBlock(), _createElementBlock("section", _hoisted_8, _hoisted_11))
      : _createCommentVNode("v-if", true),
    _createElementVNode("section", _hoisted_12, [
      _hoisted_13,
      _withDirectives(_createElementVNode("input", {
        type: "text",
        class: _normalizeClass(["form-control", { 'is-invalid': _ctx.v$.eventTitle.$error }]),
        placeholder: "Add Title",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.eventTitle) = $event)),
        onBlur: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.v$.eventTitle.$touch && _ctx.v$.eventTitle.$touch(...args)))
      }, null, 34 /* CLASS, HYDRATE_EVENTS */), [
        [_vModelText, _ctx.eventTitle]
      ]),
      (_ctx.v$.eventTitle.$error)
        ? (_openBlock(), _createElementBlock("span", _hoisted_14, "Title is required."))
        : _createCommentVNode("v-if", true),
      _hoisted_15,
      _createVNode(_component_TagsInput, {
        class: _normalizeClass(["w-100", { 'is-invalid': _ctx.v$.attendees.$error }]),
        getData: _ctx.getUsersList,
        tags: _ctx.attendees,
        onUpdateTags: _ctx.updateTags,
        placeholder: "Add Participants",
        "is-focus": true,
        "is-for-messaging": true,
        "show-user-conflict": _ctx.mode === 'create' ? true : false,
        "show-pill": false,
        classes: "w-100 form-group pt-1 mt-1",
        focusOnInput: true,
        tabindex: "1",
        disabled: _ctx.isEditingSingleOccurence
      }, null, 8 /* PROPS */, ["class", "getData", "tags", "onUpdateTags", "show-user-conflict", "disabled"]),
      (_ctx.isEditingSingleOccurence)
        ? (_openBlock(), _createElementBlock("span", _hoisted_16, "Participants can't be edited when updating a single occurrence. To modify participants, choose \"Edit entire series\""))
        : _createCommentVNode("v-if", true),
      (_ctx.v$.attendees.$error)
        ? (_openBlock(), _createElementBlock("span", _hoisted_17, "At least one participant is required."))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("section", _hoisted_18, [
      _createElementVNode("div", _hoisted_19, [
        _hoisted_20,
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("input", {
            class: "form-check-input",
            type: "checkbox",
            checked: _ctx.isAllDayEvent,
            onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.toggleAllDayEvent && _ctx.toggleAllDayEvent(...args)))
          }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_22)
        ])
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          _hoisted_25,
          _createVNode(_component_DatePicker, {
            getDate: _ctx.changeDate,
            options: {
                            orientation: 'left bottom',
                            startDate: _ctx.eventDate
                        }
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("input", {
                  type: "text",
                  class: _normalizeClass(["form-control", { 'is-invalid': _ctx.v$.eventDate.$error }]),
                  name: "eventDate",
                  placeholder: "MM/DD/YYYY",
                  value: _ctx.formatDate(_ctx.eventDate, 'MM/DD/YYYY'),
                  onBlur: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.v$.eventDate.$touch && _ctx.v$.eventDate.$touch(...args)))
                }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_27),
                _hoisted_28
              ])
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["getDate", "options"]),
          (_ctx.v$.eventDate.$error)
            ? (_openBlock(), _createElementBlock("span", _hoisted_29, "Date is required."))
            : _createCommentVNode("v-if", true)
        ]),
        (!_ctx.isAllDayEvent)
          ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
              _hoisted_31,
              _createVNode(_component_MeetingTimePicker, {
                modelValue: _ctx.startTime,
                "onUpdate:modelValue": [
                  _cache[6] || (_cache[6] = ($event: any) => ((_ctx.startTime) = $event)),
                  _cache[7] || (_cache[7] = ($event: any) => (_ctx.checkUserConflicts(_ctx.attendees)))
                ],
                minTime: _ctx.startMinTime
              }, null, 8 /* PROPS */, ["modelValue", "minTime"])
            ]))
          : _createCommentVNode("v-if", true),
        (!_ctx.isAllDayEvent)
          ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
              _hoisted_33,
              _createVNode(_component_MeetingTimePicker, {
                modelValue: _ctx.endTime,
                "onUpdate:modelValue": [
                  _cache[8] || (_cache[8] = ($event: any) => ((_ctx.endTime) = $event)),
                  _cache[9] || (_cache[9] = ($event: any) => (_ctx.checkUserConflicts(_ctx.attendees)))
                ],
                minTime: _ctx.endMinTime
              }, null, 8 /* PROPS */, ["modelValue", "minTime"])
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      _createCommentVNode(" Recurring events "),
      (!_ctx.isEditingSingleOccurence)
        ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _hoisted_36,
              _createElementVNode("select", {
                class: "form-select",
                value: _ctx.recurrenceType,
                onChange: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.handleRecurrenceChange && _ctx.handleRecurrenceChange(...args))),
                name: "recurrence"
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recurrenceTypeList, (value) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: value.value,
                    value: value.value
                  }, _toDisplayString(value.value === _ctx.RecurrenceTypeEnum.None ? "Does not repeat" : value.name), 9 /* TEXT, PROPS */, _hoisted_38))
                }), 128 /* KEYED_FRAGMENT */))
              ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_37)
            ]),
            (_ctx.showFrequency)
              ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                  _hoisted_40,
                  _createElementVNode("select", {
                    class: "form-select",
                    value: _ctx.frequency,
                    onChange: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.handleFrequencyChange && _ctx.handleFrequencyChange(...args))),
                    name: "frequency"
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.frequencyCount, (i) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: i,
                        value: i
                      }, _toDisplayString(i), 9 /* TEXT, PROPS */, _hoisted_42))
                    }), 128 /* KEYED_FRAGMENT */))
                  ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_41),
                  _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.recurrenceType === _ctx.RecurrenceTypeEnum.Weekly ? "weeks" : "months"), 1 /* TEXT */)
                ]))
              : _createCommentVNode("v-if", true),
            (_ctx.isRecurringEvent || _ctx.recurrenceType !== _ctx.RecurrenceTypeEnum.None)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (_ctx.recurrenceType === _ctx.RecurrenceTypeEnum.Weekly)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                        _hoisted_45,
                        _createVNode(_component_DayPicker, {
                          "selected-days-string": _ctx.daysOfWeek,
                          initValue: _ctx.initDayPickerValue,
                          isForMeetingCalendar: true,
                          onUpdateSelectedDays: _ctx.updateDaysOfWeek
                        }, null, 8 /* PROPS */, ["selected-days-string", "initValue", "onUpdateSelectedDays"])
                      ]))
                    : _createCommentVNode("v-if", true),
                  (_ctx.recurrenceType === _ctx.RecurrenceTypeEnum.Monthly)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                        _hoisted_47,
                        _createVNode(_component_DatePicker, {
                          getDate: _ctx.changeDate,
                          options: {
                                orientation: 'left bottom',
                                startDate: _ctx.eventDate
                            }
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_48, [
                              _createElementVNode("input", {
                                type: "text",
                                class: "form-control",
                                name: "onDate",
                                placeholder: "MM/DD/YYYY",
                                value: _ctx.formatDate(_ctx.eventDate, 'MM/DD/YYYY'),
                                disabled: ""
                              }, null, 8 /* PROPS */, _hoisted_49),
                              _hoisted_50
                            ])
                          ]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["getDate", "options"])
                      ]))
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("div", _hoisted_51, [
                    _hoisted_52,
                    _createVNode(_component_DatePicker, {
                      getDate: _ctx.changeDate,
                      options: {
                                orientation: 'left top',
                                startDate: _ctx.eventDate
                            }
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_53, [
                          _createElementVNode("input", {
                            type: "text",
                            class: "form-control",
                            name: "recurrenceEndDate",
                            placeholder: "MM/DD/YYYY",
                            value: _ctx.formatDate(_ctx.recurrenceEndDate, 'MM/DD/YYYY')
                          }, null, 8 /* PROPS */, _hoisted_54),
                          _hoisted_55
                        ])
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["getDate", "options"])
                  ]),
                  _createElementVNode("div", _hoisted_56, _toDisplayString(_ctx.occurenceText(_ctx.recurrenceStartDate, _ctx.recurrenceEndDate, _ctx.recurrenceType, _ctx.daysOfWeek)), 1 /* TEXT */)
                ], 64 /* STABLE_FRAGMENT */))
              : _createCommentVNode("v-if", true)
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("section", _hoisted_57, [
      _hoisted_58,
      _withDirectives(_createElementVNode("textarea", {
        class: "form-control",
        placeholder: "Enter description",
        rows: "4",
        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.description) = $event))
      }, null, 512 /* NEED_PATCH */), [
        [_vModelText, _ctx.description]
      ])
    ]),
    _createElementVNode("footer", _hoisted_59, [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-light border border-secondary bg-white me-2 w-30",
        onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.cancel()))
      }, " Cancel "),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-primary border border-primary w-30",
        disabled: _ctx.v$.$invalid || !_ctx.eventTitle || !_ctx.attendees.length || !_ctx.eventDate,
        onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.save()))
      }, _toDisplayString(_ctx.submitLabel), 9 /* TEXT, PROPS */, _hoisted_60)
    ])
  ]))
}